<template>
  <div class="ml-6 mr-6" :style="navbarWithName ? 'margin-left: 165px !important; margin-right: auto !important;' : ''"><!--note: mt,mb,ml,mr(margin) jangan diubah-->
  <v-breadcrumbs :items="page" class="pa-0 ma-0 my-6 mt-0 pt-0"></v-breadcrumbs>
  <v-alert class="mb-3" v-if="alert" border="top" :color="colorAlert" dark>
    {{ message }}
  </v-alert>

  <!--TOPIC DAN PERIODE BERITA-->
    <v-btn
      class="color-avatar3"
      v-scroll="onScroll"
      v-show="fab"
      fab
      dark
      fixed
      bottom
      right
      color="primary"
      @click="toBottom"
    >
      <v-icon>mdi-chevron-down</v-icon>
    </v-btn>

    <v-layout row wrap class="my-4">
      <v-col class="d-flex ma-0 pa-0" cols="12" sm="2">
        <v-select
          :items="topicsentiment"
          item-text="name1"
          item-value="name2"
          v-model="selectedTopic"
          class="elevation-0 shadow-0"
          label="Topic"
          dense
          outlined
          rounded
          @change="loadKontenBerita"
        ></v-select>
      </v-col>
      <v-col class="d-flex ma-0 pa-0 mx-3" cols="12" sm="2">
        <v-select
          :items="periodeberita"
          v-model="selectedPeriode"
          class="elevation-0"
          label="Periode Berita"
          background-color="#0471A5"
          dark
          dense
          solo
          rounded
          @change="loadKontenBerita"
        >
          <template v-slot:append-item>
            <v-list-item>
              <v-list-item-title>
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-width="200"
                  offset-x
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      small
                      dark
                      width="120"
                      color="#0471A5"
                      @click="selectedPeriode = 'Custom Date'"
                    >
                      Custom
                    </v-btn>
                  </template>
                  <v-card>
                    <v-row justify="space-around" class="ma-4">
                      <v-date-picker
                        v-model="date1"
                        dense
                        :show-current="false"
                        color="#0471A5"
                        @change="showCustomDate"
                      ></v-date-picker>
                      <v-date-picker
                        v-model="date2"
                        class="ml-8"
                        :show-current="false"
                        color="#0471A5"
                        header-color="#0471A5"
                        @change="showCustomDate"
                      ></v-date-picker>
                    </v-row>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn text @click="menu = false">
                        Cancel
                      </v-btn>
                      <v-btn color="primary" text @click="menu = false, loadKontenBerita()">
                        Set
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-list-item-title>
            </v-list-item>
          </template>
        </v-select>
      </v-col>
      <v-col class="d-flex ma-0 pa-0 mx-3" cols="12" sm="3">
        <v-card v-if="(showDate1 != '' && showDate2 != '') || selectedPeriode == 'Custom'" height="37" outlined style="border-radius: 30px;">
          <v-card-text class="pa-2 px-4">
            <v-icon>mdi-calendar</v-icon>
            <span class="mt-2 ml-1">
              {{ showDate1[1] + " " + showDate1[0] + " " + showDate1[2] }} - {{ showDate2[1] + " " + showDate2[0] + " " + showDate2[2] }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-layout>
    <!--END TOPIC DAN PERIODE BERITA-->

    <v-layout row wrap>
      <v-flex lg12>
        <v-card class="elevation-0 rounded-lg">
          <h4 class="pt-4 ml-4 font-weight-medium">
            Text Drift Current Status
          </h4>
          <div class="px-6">
            <v-row class="ma-0 pa-0 my-3">
              <v-flex lg5>
                <v-row class="my-5 mx-2">
                  <v-flex xs12 sm12 md12 lg6>
                    <v-btn color="#fff" outlined x-large width="200" height="120" class="elevation-0 mx-2 my-3" style="color: #0471A5;">
                      <v-card-text v-if="tableDataCharacteristic.length != 0">
                        <h4 align="center" justify="center" class="text--teal darken-2 my-2">
                          Drift Score
                        </h4>
                        <h2 v-if="tableDataCharacteristic[0].driftScore == 1" align="center" justify="center" class="text--teal darken-2 my-2">
                          TRUE
                        </h2>
                        <h2 v-if="tableDataCharacteristic[0].driftScore == 0" align="center" justify="center" class="text--teal darken-2 my-2">
                          FALSE
                        </h2>
                      </v-card-text>
                    </v-btn>
                  </v-flex>

                  <v-flex xs12 sm12 md12 lg6>
                    <v-btn outlined color="#fff" href="http://172.20.4.13:9901/#/dashboard" x-large width="200" height="120" class="elevation-0 mx-2 my-3" style="color: #0471A5;">
                      <v-card-text v-if="tableDataCharacteristic.length != 0">
                        <h4 align="center" justify="center" class="text--teal darken-2 my-2">
                          Out of Vocabulary
                        </h4>
                        <h2 v-if="tableDataCharacteristic[0].outOfVocabulary == 1" align="center" justify="center" class="text--teal darken-2 my-2">
                          TRUE
                        </h2>
                        <h2 v-if="tableDataCharacteristic[0].outOfVocabulary == 0" align="center" justify="center" class="text--teal darken-2 my-2">
                          FALSE
                        </h2>
                      </v-card-text>
                    </v-btn>
                  </v-flex>
                </v-row>

                <v-row class="my-4 mx-2">
                  <v-flex xs12 sm12 md12 lg6>
                    <v-btn outlined color="#fff" x-large width="200" height="120" class="elevation-0 mx-2 my-3" style="color: #0471A5;">
                      <v-card-text v-if="tableDataCharacteristic.length != 0">
                        <h4 align="center" justify="center" class="text--teal darken-2 my-2">
                          Non Letter Character
                        </h4>
                        <h2 v-if="tableDataCharacteristic[0].nonLetterCharacter == 1" align="center" justify="center" class="text--teal darken-2 my-2">
                          TRUE
                        </h2>
                        <h2 v-if="tableDataCharacteristic[0].nonLetterCharacter == 0" align="center" justify="center" class="text--teal darken-2 my-2">
                          FALSE
                        </h2>
                      </v-card-text>
                    </v-btn>
                  </v-flex>

                  <v-flex xs12 sm12 md12 lg6>
                    <v-btn outlined color="#fff" x-large width="200" height="120" class="elevation-0 mx-2 my-3" style="color: #0471A5;">
                      <v-card-text v-if="tableDataCharacteristic.length != 0">
                        <h4 align="center" justify="center" class="text--teal darken-2 my-2">
                          Text Length
                        </h4>
                        <h2 v-if="tableDataCharacteristic[0].textLength == 1" align="center" justify="center" class="text--teal darken-2 my-2">
                          TRUE
                        </h2>
                        <h2 v-if="tableDataCharacteristic[0].textLength == 0" align="center" justify="center" class="text--teal darken-2 my-2">
                          FALSE
                        </h2>
                      </v-card-text>
                    </v-btn>
                  </v-flex>
                </v-row>
              </v-flex>
              <v-flex lg7>
                <v-row class="ma-0 pa-0">
                  <v-flex lg12 md12>
                    <v-card-text class="d-flex align-end flex-column">
                      <div>
                        <v-dialog v-model="dialoginfo" width="500">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              small
                              icon
                              color="#0471A5"
                            >
                              <v-icon>mdi-information-outline</v-icon>
                            </v-btn>
                          </template>

                          <v-card>
                            <v-card-title class="text-h5">
                              Lorem Ipsum
                            </v-card-title>
                            <v-card-text>
                              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt 
                              ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco 
                              laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate 
                              velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, 
                              sunt in culpa qui officia deserunt mollit anim id est laborum.
                            </v-card-text>

                            <v-divider></v-divider>

                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="primary" text @click="dialoginfo = false">
                                Cancel
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                      </div>
                    </v-card-text>
                  </v-flex>
                </v-row>
                <apexcharts
                  :options="sentimentanalysis"
                  :series="seriessentiment"
                  class="mr-3"
                  type=""
                  width="100%"
                  height="220px"
                ></apexcharts>
                <v-card-text>
                  <h5 class="mb-2">Threshold</h5>
                  <v-row class="ma-0 pa-0">
                    <v-flex lg1>
                      <img src="Threshold_drift_score.png" width="30" alt="">
                    </v-flex>
                    <v-flex lg3>
                      Threshold for Drift Score
                    </v-flex>
                  </v-row>
                  <v-row class="ma-0 pa-0 my-2">
                    <v-flex lg1>
                      <img src="Threshold_oov.png" width="30" alt="">
                    </v-flex>
                    <v-flex lg8>
                      Threshold for OOV, Non Letter Character and Text Length
                    </v-flex>
                  </v-row>
                </v-card-text>
              </v-flex>
            </v-row>
          </div>
        </v-card>
      </v-flex>
      <v-flex lg12>
        <v-card class="elevation-0">
          <div class="example my-4">
            <h4 class="pt-4 ml-4 font-weight-medium">
              Data Characteristic
            </h4>
            <div class="px-6">
              <v-simple-table height="350px" class="table-stripped elevation-0 overflow-card mb-4 py-4">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">
                        Metrics
                      </th>
                      <th class="text-left">
                        Reference
                      </th>
                      <th class="text-left">
                        Current
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Count</td>
                      <td>{{tableDataCharacteristic[0].countReference}}</td>
                      <td>{{tableDataCharacteristic[0].countCurrent}}</td>
                    </tr>
                    <tr>
                      <td>Missing</td>
                      <td>{{tableDataCharacteristic[0].missingReference}}</td>
                      <td>{{tableDataCharacteristic[0].missingCurrent}}</td>
                    </tr>
                    <tr>
                      <td>Non Letter Character (Max)</td>
                      <td>{{tableDataCharacteristic[0].nonLetterMaxReference}}</td>
                      <td>{{tableDataCharacteristic[0].nonLetterMaxCurrent}}</td>
                    </tr>
                    <tr>
                      <td>Non Letter Character (Mean)</td>
                      <td>{{tableDataCharacteristic[0].nonLetterMeanReference}}</td>
                      <td>{{tableDataCharacteristic[0].nonLetterMeanCurrent}}</td>
                    </tr>
                    <tr>
                      <td>Non Letter Character (Min)</td>
                      <td>{{tableDataCharacteristic[0].nonLetterMinReference}}</td>
                      <td>{{tableDataCharacteristic[0].nonLetterMinCurrent}}</td>
                    </tr>
                    <tr>
                      <td>OOV (Max)</td>
                      <td>{{tableDataCharacteristic[0].oovMaxReference}}</td>
                      <td>{{tableDataCharacteristic[0].oovMaxCurrent}}</td>
                    </tr>
                    <tr>
                      <td>OOV (Mean)</td>
                      <td>{{tableDataCharacteristic[0].oovMeanReference}}</td>
                      <td>{{tableDataCharacteristic[0].oovMeanCurrent}}</td>
                    </tr>
                    <tr>
                      <td>OOV (Min)</td>
                      <td>{{tableDataCharacteristic[0].oovMinReference}}</td>
                      <td>{{tableDataCharacteristic[0].oovMinCurrent}}</td>
                    </tr>
                    <tr>
                      <td>Text Length (Max)</td>
                      <td>{{tableDataCharacteristic[0].textLengthMaxReference}}</td>
                      <td>{{tableDataCharacteristic[0].textLengthMaxCurrent}}</td>
                    </tr>
                    <tr>
                      <td>Text Length (Mean)</td>
                      <td>{{tableDataCharacteristic[0].textLengthMeanReference}}</td>
                      <td>{{tableDataCharacteristic[0].textLengthMeanCurrent}}</td>
                    </tr>
                    <tr>
                      <td>Text Length (Min)</td>
                      <td>{{tableDataCharacteristic[0].textLengthMinReference}}</td>
                      <td>{{tableDataCharacteristic[0].textLengthMinCurrent}}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </div>
        </v-card>
      </v-flex>

      <v-divider></v-divider>

      <v-flex lg12>
        <v-card class="my-4 mb-6 rounded-lg" flat>
          <v-row class="ma-0 pa-0">
            <v-flex lg6>
              <h4 class="pt-4 ml-4 font-weight-medium">
                Data Distribution
              </h4>
            </v-flex>
            <v-flex lg6 md6>
              <v-card-text class="d-flex align-end flex-column">
                <div>
                  <v-dialog v-model="dialoginfo" width="500">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        small
                        icon
                        color="#0471A5"
                      >
                        <v-icon>mdi-information-outline</v-icon>
                      </v-btn>
                    </template>

                    <v-card>
                      <v-card-title class="text-h5">
                        Data Distribution
                      </v-card-title>
                      <v-card-text>
                        <p>
                          <bold class="font-weight-bold">Text Length:</bold> Compare the distribution of reference and current data in terms of how long the text for each rows
                        </p>
                        <p>
                          <bold class="font-weight-bold">Non-Letter Character %:</bold> Compare the distribution of reference and current data in terms of non letter character prencentage for each rows
                        </p>
                        <p>
                          <bold class="font-weight-bold">Out of Vocabulary %(OOV %):</bold> Compare the distributor of reference and current data in terms of out of vocabulary for each rows
                        </p>
                      </v-card-text>

                      <v-divider></v-divider>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text @click="dialoginfo = false">
                          Cancel
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </div>
              </v-card-text>
            </v-flex>
          </v-row>
          <v-row class="ma-0 pa-0">
            <v-flex lg4>
              <v-card height="350px" class="mr-4 mb-6 rounded-lg" flat>
                <v-flex lg12>
                  <div class="example">
                    <h4 class="pt-4 ml-4 font-weight-medium">
                      Text Length
                    </h4>
                    <div class="px-6">
                      <apexchart
                        :options="barchart2"
                        :series="series2"
                        type="bar"
                        height="300"
                      ></apexchart>
                    </div>
                  </div>
                </v-flex>
              </v-card>
            </v-flex>
            <v-flex lg4>
              <v-card height="350px" class="mr-4 mb-6 rounded-lg" flat>
                <v-flex lg12>
                  <div class="example">
                    <h4 class="pt-4 ml-4 font-weight-medium">
                      Non Letter Character %
                    </h4>
                    <div class="px-6">
                      <apexchart
                        :options="barchart"
                        :series="series1"
                        type="bar"
                        height="300"
                      ></apexchart>
                    </div>
                  </div>
                </v-flex>
              </v-card>
            </v-flex>
            <v-flex lg4>
              <v-card height="350px" class="mr-4 mb-6 rounded-lg" flat>
                <v-flex lg12>
                  <div class="example">
                    <h4 class="pt-4 ml-4 font-weight-medium">
                      OOV %
                    </h4>
                    <div class="px-6">
                      <apexchart
                        :options="barchart3"
                        :series="series3"
                        type="bar"
                        height="300"
                      ></apexchart>
                    </div>
                  </div>
                </v-flex>
              </v-card>
            </v-flex>
          </v-row>
        </v-card>
      </v-flex>
      <v-dialog v-model="dialogLoading" persistent max-width="290">
        <v-card>
          <v-card-title class="text-h6 font-weight-medium align-center justify-center">
            Page loading
          </v-card-title>
          <v-card-text class="body-1 align-center justify-center">
            Loading content, please wait
          </v-card-text>
          <v-card-title class="align-center justify-center">
            <v-progress-circular
              :size="70"
              :width="7"
              color="#0471A5"
              indeterminate
            ></v-progress-circular>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#0471A5" text @click="dialogLoading = false">
              cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import axios from "axios";
import { mapGetters } from 'vuex';

export default {
  components: {
    apexcharts: VueApexCharts,
  },
  data() {
    return {
      setTanggal: [],
      driftScoreGrafik: [],
      oovGrafik: [],
      nonLetterGrafik: [],
      textLengthGrafik: [],
      tableDataCharacteristic: [],
      selectedTopic: "bnpt",
      selectedPeriode: "Last 7 Days",
      dateStart: "",
      dateEnd: "",
      topicsentiment: [
        { name1: "BNPT", name2: "bnpt" },
        { name1: "Economy", name2: "economy" },
        { name1: "Internet", name2: "internet" },
        { name1: "Lifestyle", name2: "lifestyle" },
        { name1: "Politik", name2: "politik" }
      ],
      periodeberita: [
        "Today",
        "Yesterday",
        "Last 7 Days",
        "Previous Week",
        "Last 30 Days",
        "Previous Month",
      ],
      date1: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      date2: new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      showDate1 : "",
      showDate2: "",
      dialogLoading: false,
      dialoginfo: false,
      menu: false,
      alert: false,
      colorAlert: "",
      message : "",
      /*Chart sentiment analysis*/
      sentimentanalysis: {
        chart: { id: "Memory Usage", type: "line" },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          width: 2,
        },
        colors: ["#69A3D9", "#FD781E", "#A9A9A9", "#FFC20A"] /*color line*/,
        xaxis: {
          categories: [],
        },
      },
      seriessentiment: [
        {
          name: "Drift Score",
          data: [],
        },
        {
          name: "Out of Vocabulary",
          data: [],
        },
        {
          name: "Non Letter Character",
          data: [],
        },
        {
          name: "Text Length",
          data: [],
        },
      ],

      /*bar chart*/
      series1: [
        {
          name: "Reference",
          data: [],
        },
        {
          name: "Current",
          data: [],
        },
      ],
      barchart: {
        type: "bar",
        height: 350,
        dataLabels: {
          enabled: false,
          endingShape: true,
        },
        xaxis: {
          categories: []
        },
      },

      series2: [
        {
          name: "Reference",
          data: [],
        },
        {
          name: "Current",
          data: [],
        },
      ],
      series3: [
        {
          name: "Reference",
          data: [],
        },
        {
          name: "Current",
          data: [],
        },
      ],
      barchart2: {
        type: "bar",
        height: 350,
        dataLabels: {
          enabled: false,
          endingShape: true,
        },
        xaxis: {
          categories: []
        },
      },
      barchart3: {
        type: "bar",
        height: 350,
        dataLabels: {
          enabled: false,
          endingShape: true,
        },
        xaxis: {
          categories: [],
        },
      },
    };
  },
  computed: {
    ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
  },
  mounted() {
    this.loadKontenBerita();
  },
  methods: {
    showCustomDate() {
      var date = new Date(this.date1);
      var day2 = (date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) + "/" +
        (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) + "/" +
        date.getFullYear();

      const parts = day2.split("/");
      parts.unshift(parts.pop());
      parts[1] -= 1;
      var dateString = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts)).replace(/,/g, "");

      dateString = dateString.split(" ");
      this.showDate1 = dateString;

      var date3 = new Date(this.date2);
      var day4 = (date3.getMonth() > 8 ? date3.getMonth() + 1 : "0" + (date3.getMonth() + 1)) + "/" +
        (date3.getDate() > 9 ? date3.getDate() : "0" + date3.getDate()) + "/" +
        date3.getFullYear();

      const parts2 = day4.split("/");
      parts2.unshift(parts2.pop());
      parts2[1] -= 1;
      var dateString2 = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts2)).replace(/,/g, "");

      dateString2 = dateString2.split(" ");
      this.showDate2 = dateString2;
    },
    async loadKontenBerita() {
      this.dialogLoading = true;
      try {
        const date_awal = new Date();
        const date = new Date();
        date.setDate(date.getDate()+0);
        const datenow = date.toISOString().substr(0, 10);
        if (this.selectedPeriode == "Today") {
          this.click = 'Today'
          this.dateStart = datenow;
          this.dateEnd = datenow;
        }
        if (this.selectedPeriode == "Yesterday") {
          this.click = 'Yesterday'
          date_awal.setDate(date_awal.getDate()-1);
          const date_c = date_awal.toISOString().substr(0, 10);
          this.dateStart = date_c;
          this.dateEnd = date_c;
        }
        if (this.selectedPeriode == "Last 7 Days" ||  this.selectedPeriode == "Previous Week") {
          this.click = 'Last 7 Days'
          date_awal.setDate(date_awal.getDate()-7);
          const date_c = date_awal.toISOString().substr(0, 10);
          this.dateStart = date_c;
          this.dateEnd = datenow;
        }
        if (this.selectedPeriode == "Last 30 Days" || this.selectedPeriode == "Previous Month") {
          this.click = 'Last 30 Days'
          date_awal.setDate(date_awal.getDate()-30);
          const date_c = date_awal.toISOString().substr(0, 10);
          this.dateStart = date_c;
          this.dateEnd = datenow;
        }
        if (this.selectedPeriode == "Custom Date") {
          this.click = 'Custom Date'
          this.dateStart = this.date1;
          this.dateEnd = this.date2
        }
        const data1 = await axios.get(`http://172.20.4.11:5122/get/?topic=${this.selectedTopic}&start_date=${this.dateStart}&end_date=${this.dateEnd}`);
        const data = data1.data;
        var length = data.length;
        if (data1.data[length-1]) {
          var array = [];
          array.push(data1.data[length-1]);
          // console.log('do this')
          let data2 = array.map((x) => {
            return {
              driftScore: x.text_drift_drift_detected,
              outOfVocabulary: x.text_desc_drift_detected_oov_percent,
              nonLetterCharacter: x.text_desc_drift_detected_non_letter_character_percent,
              textLength: x.text_desc_drift_detected_text_length,
              countCurrent: x.count_current_characteristics,
              countReference: x.count_reference_characteristics,
              missingCurrent: x.missing_current_characteristics,
              missingReference: x.missing_reference_characteristics,
              nonLetterMaxCurrent: x.non_letter_char_max_current_characteristics,
              nonLetterMeanCurrent: x.non_letter_char_mean_current_characteristics,
              nonLetterMinCurrent: x.non_letter_char_min_current_characteristics,
              nonLetterMaxReference: x.non_letter_char_max_reference_characteristics,
              nonLetterMeanReference: x.non_letter_char_mean_reference_characteristics,
              nonLetterMinReference: x.non_letter_char_min_reference_characteristics,
              oovMaxCurrent: x.oov_max_current_characteristics,
              oovMeanCurrent: x.oov_mean_current_characteristics,
              oovMinCurrent: x.oov_min_current_characteristics,
              oovMaxReference: x.oov_max_reference_characteristics,
              oovMeanReference: x.oov_mean_reference_characteristics,
              oovMinReference: x.oov_min_reference_characteristics,
              textLengthMaxCurrent: x.text_length_max_current_characteristics,
              textLengthMeanCurrent: x.text_length_mean_current_characteristics,
              textLengthMinCurrent: x.text_length_min_current_characteristics,
              textLengthMaxReference: x.text_length_max_reference_characteristics,
              textLengthMeanReference: x.text_length_mean_reference_characteristics,
              textLengthMinReference: x.text_length_min_reference_characteristics,
              textLengthCurrentY: x.text_desc_current_distribution_y_text_length,
              textLengthCurrentX: x.text_desc_current_distribution_x_text_length,
              textLengthReferenceY: x.text_desc_reference_distribution_y_text_length,
              textLengthReferenceX: x.text_desc_reference_distribution_x_text_length,
              nonLetterReferenceY: x.text_desc_reference_distribution_y_non_letter_character_percent,
              nonLetterReferenceX: x.text_desc_reference_distribution_x_non_letter_character_percent,
              nonLetterCurrentY: x.text_desc_current_distribution_y_non_letter_character_percent,
              nonLetterCurrentX: x.text_desc_current_distribution_x_non_letter_character_percent,
              oovReferenceY: x.text_desc_reference_distribution_y_oov_percent,
              oovReferenceX: x.text_desc_reference_distribution_x_oov_percent,
              oovCurrentY: x.text_desc_current_distribution_y_oov_percent,
              oovCurrentX: x.text_desc_current_distribution_x_oov_percent,
            }
          })
          this.tableDataCharacteristic = data2;
          this.series2[0].data = this.tableDataCharacteristic[0].textLengthReferenceY.replace('[','').replace(']','').split(",");
          this.series2[1].data = this.tableDataCharacteristic[0].textLengthCurrentY.replace('[','').replace(']','').split(",");
          this.series1[0].data = this.tableDataCharacteristic[0].nonLetterReferenceY.replace('[','').replace(']','').split(",");
          this.series1[1].data = this.tableDataCharacteristic[0].nonLetterCurrentY.replace('[','').replace(']','').split(",");
          this.series3[0].data = this.tableDataCharacteristic[0].oovReferenceY.replace('[','').replace(']','').split(",");
          this.series3[1].data = this.tableDataCharacteristic[0].oovCurrentY.replace('[','').replace(']','').split(",");
          this.barchart2.xaxis.categories = this.tableDataCharacteristic[0].textLengthReferenceX.replace('[','').replace(']','').split(",");
          this.barchart2.xaxis.categories = this.tableDataCharacteristic[0].textLengthCurrentX.replace('[','').replace(']','').split(",");
          this.barchart.xaxis.categories = this.tableDataCharacteristic[0].nonLetterReferenceX.replace('[','').replace(']','').split(",");
          this.barchart.xaxis.categories = this.tableDataCharacteristic[0].nonLetterReferenceX.replace('[','').replace(']','').split(",");
          this.barchart3.xaxis.categories = this.tableDataCharacteristic[0].oovReferenceX.replace('[','').replace(']','').split(",");
          this.barchart3.xaxis.categories = this.tableDataCharacteristic[0].oovCurrentX.replace('[','').replace(']','').split(",");

          this.setTanggal = [];
          this.driftScoreGrafik = [];
          this.oovGrafik = [];
          this.nonLetterGrafik = [];
          this.textLengthGrafik = [];
          for (let i = 0; i < data.length; i++) {
            this.setTanggal.push(data[i].analysis_timestamp);
          }
          for (let a = 0; a < data.length; a++) {
            this.driftScoreGrafik.push(data[a].text_drift_drift_score);
          }
          for (let a = 0; a < data.length; a++) {
            this.oovGrafik.push(data[a].text_desc_drift_score_oov_percent);
          }
          for (let a = 0; a < data.length; a++) {
            this.nonLetterGrafik.push(data[a].text_desc_drift_score_non_letter_character_percent);
          }
          for (let a = 0; a < data.length; a++) {
            this.textLengthGrafik.push(data[a].text_desc_drift_score_text_length);
          }
          if (this.setTanggal.length == 1) {
            this.setTanggal.push("");
            this.driftScoreGrafik.push(0);
            this.oovGrafik.push(0);
            this.nonLetterGrafik.push(0);
            this.textLengthGrafik.push(0);
          }
          window.dispatchEvent(new Event('resize'));
          this.sentimentanalysis = {...this.sentimentanalysis, ...{
            xaxis: {
              categories: this.setTanggal,
            }
          }}
          this.seriessentiment[0].data = this.driftScoreGrafik;
          this.seriessentiment[1].data = this.oovGrafik;
          this.seriessentiment[2].data = this.nonLetterGrafik;
          this.seriessentiment[3].data = this.textLengthGrafik;
          console.log(this.tableDataCharacteristic);
          console.log(data);
          this.dialogLoading = false;
        } else {
          console.log('do undefined');
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 3000);
          this.message = "Data Not Found";
          this.colorAlert = "red";
          this.setTanggal = [];
          this.driftScoreGrafik = [];
          this.oovGrafik = [];
          this.nonLetterGrafik = [];
          this.textLengthGrafik = [];
          window.dispatchEvent(new Event('resize'));
          this.sentimentanalysis = {...this.sentimentanalysis, ...{
            xaxis: {
              categories: this.setTanggal,
            }
          }}
          this.seriessentiment[0].data = this.driftScoreGrafik;
          this.seriessentiment[1].data = this.oovGrafik;
          this.seriessentiment[2].data = this.nonLetterGrafik;
          this.seriessentiment[3].data = this.textLengthGrafik;
          this.tableDataCharacteristic[0].driftScore = "";
          this.tableDataCharacteristic[0].outOfVocabulary = "";
          this.tableDataCharacteristic[0].nonLetterCharacter = "";
          this.tableDataCharacteristic[0].textLength = "";
          this.tableDataCharacteristic[0].countCurrent = "";
          this.tableDataCharacteristic[0].countReference = "";
          this.tableDataCharacteristic[0].missingCurrent = "";
          this.tableDataCharacteristic[0].missingReference = "";
          this.tableDataCharacteristic[0].nonLetterMaxCurrent = "";
          this.tableDataCharacteristic[0].nonLetterMeanCurrent = "";
          this.tableDataCharacteristic[0].nonLetterMinCurrent = "";
          this.tableDataCharacteristic[0].nonLetterMaxReference = "";
          this.tableDataCharacteristic[0].nonLetterMeanReference = "";
          this.tableDataCharacteristic[0].nonLetterMinReference = "";
          this.tableDataCharacteristic[0].oovMaxCurrent = "";
          this.tableDataCharacteristic[0].oovMeanCurrent = "";
          this.tableDataCharacteristic[0].oovMinCurrent = "";
          this.tableDataCharacteristic[0].oovMaxReference = "";
          this.tableDataCharacteristic[0].oovMeanReference = "";
          this.tableDataCharacteristic[0].oovMinReference = "";
          this.tableDataCharacteristic[0].textLengthMaxCurrent = "";
          this.tableDataCharacteristic[0].textLengthMeanCurrent = "";
          this.tableDataCharacteristic[0].textLengthMinCurrent = "";
          this.tableDataCharacteristic[0].textLengthMaxReference = "";
          this.tableDataCharacteristic[0].textLengthMeanReference = "";
          this.tableDataCharacteristic[0].textLengthMinReference = "";
          this.tableDataCharacteristic[0].textLengthCurrentY = [];
          this.tableDataCharacteristic[0].textLengthReferenceY = [];
          this.tableDataCharacteristic[0].textLengthReferenceX = [];
          this.tableDataCharacteristic[0].nonLetterReferenceY = [];
          this.tableDataCharacteristic[0].nonLetterReferenceX = [];
          this.tableDataCharacteristic[0].nonLetterCurrentY = [];
          this.tableDataCharacteristic[0].nonLetterCurrentX = [];
          this.tableDataCharacteristic[0].oovReferenceY = [];
          this.tableDataCharacteristic[0].oovReferenceX = [];
          this.tableDataCharacteristic[0].oovCurrentY = [];
          this.tableDataCharacteristic[0].oovCurrentX = [];
          this.series2[0].data = this.tableDataCharacteristic[0].textLengthReferenceY;
          this.series2[1].data = this.tableDataCharacteristic[0].textLengthCurrentY;
          this.series1[0].data = this.tableDataCharacteristic[0].nonLetterReferenceY;
          this.series1[1].data = this.tableDataCharacteristic[0].nonLetterCurrentY;
          this.series3[0].data = this.tableDataCharacteristic[0].oovReferenceY;
          this.series3[1].data = this.tableDataCharacteristic[0].oovCurrentY;
          this.barchart2.xaxis.categories = this.tableDataCharacteristic[0].textLengthReferenceX;
          this.barchart2.xaxis.categories = this.tableDataCharacteristic[0].textLengthCurrentX;
          this.barchart.xaxis.categories = this.tableDataCharacteristic[0].nonLetterReferenceX;
          this.barchart.xaxis.categories = this.tableDataCharacteristic[0].nonLetterReferenceX;
          this.barchart3.xaxis.categories = this.tableDataCharacteristic[0].oovReferenceX;
          this.barchart3.xaxis.categories = this.tableDataCharacteristic[0].oovCurrentX;
          this.dialogLoading = false;
        }
      } catch (e) {
        console.log(e);
        console.log('do catch');
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 3000);
        this.message = "Data Not Found";
        this.colorAlert = "red";
        this.setTanggal = [];
        this.driftScoreGrafik = [];
        this.oovGrafik = [];
        this.nonLetterGrafik = [];
        this.textLengthGrafik = [];
        window.dispatchEvent(new Event('resize'));
        this.sentimentanalysis = {...this.sentimentanalysis, ...{
          xaxis: {
            categories: this.setTanggal,
          }
        }}
        this.seriessentiment[0].data = this.driftScoreGrafik;
        this.seriessentiment[1].data = this.oovGrafik;
        this.seriessentiment[2].data = this.nonLetterGrafik;
        this.seriessentiment[3].data = this.textLengthGrafik;
        this.tableDataCharacteristic = [];
        this.series2[0].data = this.tableDataCharacteristic[0].textLengthReferenceY;
        this.series2[1].data = this.tableDataCharacteristic[0].textLengthCurrentY;
        this.series1[0].data = this.tableDataCharacteristic[0].nonLetterReferenceY;
        this.series1[1].data = this.tableDataCharacteristic[0].nonLetterCurrentY;
        this.series3[0].data = this.tableDataCharacteristic[0].oovReferenceY;
        this.series3[1].data = this.tableDataCharacteristic[0].oovCurrentY;
        this.barchart2.xaxis.categories = this.tableDataCharacteristic[0].textLengthReferenceX;
        this.barchart2.xaxis.categories = this.tableDataCharacteristic[0].textLengthCurrentX;
        this.barchart.xaxis.categories = this.tableDataCharacteristic[0].nonLetterReferenceX;
        this.barchart.xaxis.categories = this.tableDataCharacteristic[0].nonLetterReferenceX;
        this.barchart3.xaxis.categories = this.tableDataCharacteristic[0].oovReferenceX;
        this.barchart3.xaxis.categories = this.tableDataCharacteristic[0].oovCurrentX;
        this.dialogLoading = false;
      }
    },
  }
};
</script>

<style>
/*note css jangan diubah*/
.v-sheet--offset {
  top: -24px;
  position: relative;
}
.apexcharts-toolbar {
  z-index: 0;
}
.row-pointer {
  cursor: grab;
}
svg {
  display: block;
  margin: 0 auto;
}
.chart {
  transition: transform 0.7s ease-in-out;
  text-anchor: middle;
  cursor: pointer;
}
.chart__circle {
  transition: r 0.3s ease-in-out;
}
.chart__label {
  fill: #fff;
  font-weight: bold;
  font-size: 12px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}
.v-select.label {
  color: #fff;
}
.overflow-card {
  overflow-y: scroll;
  overflow-x: hidden;
}
.v-avatar.color-avatar {
  background-image: linear-gradient(
    to right top,
    #5a6fe8,
    #6174ea,
    #6879ed,
    #6f7fef,
    #7584f1,
    #7d8af3,
    #8590f5,
    #8d96f7,
    #989ff9,
    #a2a7fb,
    #acb0fd,
    #b6b9ff
  );
}
.v-avatar.color-avatar2 {
  background-image: linear-gradient(
    to right top,
    #fd2f2c,
    #fe3b37,
    #fe4542,
    #fe4e4c,
    #fe5756,
    #fe6062,
    #fe696e,
    #fd7279,
    #fc7e88,
    #fa8a96,
    #f796a3,
    #f3a2af
  );
}
.v-avatar.color-avatar3 {
  background-image: linear-gradient(
    to right top,
    #5d8de3,
    #5c92e4,
    #5b96e5,
    #5c9be6,
    #5d9fe6,
    #5da3e7,
    #5ea6e7,
    #5faae8,
    #5faee9,
    #5fb2ea,
    #60b6eb,
    #61baec
  );
}
.v-avatar.color-avatar4 {
  background-image: linear-gradient(
    to right top,
    #53d166,
    #5dd468,
    #65d769,
    #6eda6b,
    #76dd6d,
    #7ee06f,
    #86e271,
    #8de573,
    #96e876,
    #9fec79,
    #a8ef7c,
    #b1f27f
  );
}
.v-avatar.color-avatar5 {
  background-image: linear-gradient(
    to right top,
    #fac070,
    #fcc46a,
    #fec864,
    #ffcc5e,
    #ffd057,
    #ffd359,
    #ffd65a,
    #ffd95c,
    #ffdb66,
    #ffde6f,
    #ffe079,
    #ffe282
  );
}
.highcharts-figure,
.highcharts-data-table table {
  min-width: 320px;
  max-width: 800px;
  margin: 1em auto;
}
.highcharts-data-table table {
  font-family: Verdana, sans-serif;
  border-collapse: collapse;
  border: 1px solid #ebebeb;
  margin: 10px auto;
  text-align: center;
  width: 100%;
  max-width: 500px;
}
.highcharts-data-table caption {
  padding: 1em 0;
  font-size: 1.2em;
  color: #555;
}
.highcharts-data-table th {
  font-weight: 600;
  padding: 0.5em;
}
.highcharts-data-table td,
.highcharts-data-table th,
.highcharts-data-table caption {
  padding: 0.8em;
}
.highcharts-data-table thead tr,
.highcharts-data-table tr:nth-child(even) {
  background: #f8f8f8;
}
.highcharts-data-table tr:hover {
  background: #f1f7ff;
}
.rounded-lg {
  border-radius: 10px;
}
tbody tr:nth-of-type(even) {
  background-color: #fff;
}

tbody tr:nth-of-type(odd) {
  background-color: #e7f2f7;
}

.v-data-table-header {
  background-color: #fff;
  color: white;
}

.v-data-footer {
  background-color: #e7f2f7;
}

.theme--light.v-data-table thead tr th {
  color: white;
}
</style>